export default __webpack_public_path__ + "static/media/filter-icon.fc488ea4.svg";